var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.svg = {
	init: function () {
		$('img[src*=".svg"]').each(function() {
			var $img = $(this);
			$.get($img.attr('src'), function(data) {
				var $svg = $(data).find('svg').removeAttr('xmlns:a');
				$.each($img.prop('attributes'), function() {
					$svg.attr(this.name, this.value);
				});
				$img.replaceWith($svg);
			}, 'xml');
		});
	}
};

site.footerImg = {
	init: function () {
		$('footer img').each(function() {
			$(this).wrap('<div class="footer_image"></div>');
		});
	}
};

site.mainHeight = {
	init: function () {
		var $aside = $('aside').height();
		var $main = $('main > .box > .boxText');
		$main.css('min-height', $aside + 194);
	}
};

site.frontpage = {
	init: function() {
		$('.image', '#custom-banner').bgLoaded();

		site.owl.init('#custom-banner .items', {
			loop: true,
			dots: false,
			nav: false,
			autoplay: true,
			autoplayTimeout: 5000,
			navText: ["", ""],
			items: 1
		});
	}
};

// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	},

	rowHeight: function () {
		var biggest = 0;
		var number = 0;
		$('.centerBox > * .wrapper').each(function () {
			if($(this).height() > biggest) {
				biggest = $(this).height();
				number++;
			}
		});

		if (number === 1) {
			$('.centerBox').addClass('firstBox');
		}
	}
};

site.processnav = {
	init: function() {
		var $processNavSlicks = {
			infinite: true,
			responsive: [
				{
					breakpoint: 550,
					settings: {
						slidesToShow: 2.07,
					},
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 3.07,
					},
				},
			],
		};
		if ($(window).width() < 768) {
			$('nav.processnav').slick($processNavSlicks);
		}

		$(window).resize(function () {
			if ($(window).width() < 768) {
				if ($('nav.processnav.slick-slider').length === 0) {
					$('nav.processnav').slick($processNavSlicks);
				}
			} else {
				if ($('nav.processnav.slick-slider').length > 0) {
					$('nav.processnav.slick-slider').slick('unslick');
				}
			}
		});
	}
};

site.resources = {
	init: function() {
		site.resources.initFilter();
	},

	initFilter: function() {
		var $grid = $('#extras .items').isotope({
				itemSelector: '.item',
				layoutMode: 'fitRows'
			}),

			activeFilters = [],

			getActiveFilters = function() {
				return activeFilters.join(', ');
			},
			addActiveFilter = function(filter) {
				activeFilters.push(filter);
			},
			removeActiveFilter = function(filter) {
				activeFilters = activeFilters.filter(function(e) { return e !== filter })
			};


		$('.itemFilter').on('click', 'a', function(e) {
			e.preventDefault();

			var $this = $(this);
			var filterValue = '.' + $this.attr('href').slice(1);

			if ($this.hasClass('all')) {
				if (!$this.hasClass('selected')) {
					$this.siblings().each(function() {
						var $sibling = $(this);
						$sibling.removeClass('selected');
						removeActiveFilter('.' + $sibling.attr('href').slice(1));
					});
					$this.addClass('selected');
				}
			}
			else {
				$(this).closest('div').find('.all').removeClass('selected');

				if (!$this.hasClass('selected')) {
					$this.addClass('selected');
					addActiveFilter(filterValue);

					if ($this.hasClass('single')) {
						$this.siblings().each(function() {
							var $sibling = $(this);
							$sibling.removeClass('selected');
							removeActiveFilter('.' + $sibling.attr('href').slice(1));
						});
					}
				}
				else {
					$this.removeClass('selected');
					removeActiveFilter(filterValue);
				}
			}

			if (activeFilters.length === 0) {
				$(this).closest('div').find('.all').addClass('selected');
			}

			$this.blur();
			$grid.isotope({ filter: getActiveFilters() });
		});

		$('select', '.selectFilter').on('focus', function () {
			removeActiveFilter(this.value);
		}).change(function() {
			addActiveFilter(this.value);
			$grid.isotope({ filter: getActiveFilters() });
			$(this).blur();
		});

	}
};

site.datafilter = {
	options: {
		checkGroups: true
	}
};

site.accordion = {
	getOpenOffset: function() {
		return 9;
	},
	shouldAddHashes: true,
	shouldUpdateHash: true,
	shouldFollowHash: true,
};

site.readspeker = {
	init: function() {
		window.rsConf = {
			general: {usePost: true}
		};
		site.readspeker.accordionFix();
	},
	accordionFix: function() {
		var $accordions = $('.accordion');
		if (!$accordions.length) {
			return;
		}
		$accordions.removeClass('rs_preserve');

		document.addEventListener('DOMContentLoaded', ReadSpeaker.q(function() {
			var $current;
			rspkr.c.addEvent('onBeforeSync', function(type, id) {
				var element = $rs.get('#sync' + id),
					$parent = $(element.parentElement);

				if (!$current || $current[0] !== $parent[0]) {
					var $closedAccordion = $parent.parents('.accordion:not(.open)');
					if ($closedAccordion.length) {
						$closedAccordion.addClass('open');
					}
					$current = $parent;
				}
			});
		}), false);
	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	site.svg.init();
	site.footerImg.init();
	site.megamenu.init();
	site.labelFocus.init();
	site.readspeker.init();

	$('.box_extras_items .successstories.items').slick({
		slidesToShow: 4,
		swipeToSlide: true,
		infinite: false,
		arrows: true,
		lazyLoad: 'anticipated',
		prevArrow:"<button type='button' class='slick-prev pull-left' aria-label='Fyrra'><i class='fas fa-chevron-left' aria-hidden='true'></i></button>",
		nextArrow:"<button type='button' class='slick-next pull-right' aria-label='Næsta'><i class='fas fa-chevron-right' aria-hidden='true'></i></button>",

		responsive: [
			{
				breakpoint: 1300,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 880,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 580,
				settings: {
					slidesToShow: 1
				}
			}
		]

	});

	var $body = $('body');
	if(!$body.is('.btwFront')) {
		site.mainHeight.init();
	}
	if ($body.is('.frontpage')) {
		site.frontpage.init();
		site.layout.rowWrap('.frontAd', '.frontTextBox', 'centerBox');
		site.layout.rowHeight();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', 'main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', 'main').wrap('<div class="table-responsive"></div>');
	}

	$('.shareThis').click(function(e) {
		e.preventDefault();
		var width = ($(this).data('width') !== undefined) ? $(this).data('width') : 550;
		var height = ($(this).data('height') !== undefined) ? $(this).data('height') : 500;
		popCenter($(this).attr('href'), 'shareWindow', width, height);
	});

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);

	$body.removeClass('preload');
});

function popCenter(url, title, w, h) {
	var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
	var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

	var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
	var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

	var left = ((width / 2) - (w / 2)) + dualScreenLeft;
	var top = ((height / 2) - (h / 2)) + dualScreenTop;
	var newWindow = window.open(url, title, 'scrollbars=0, toolbar=0, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

	// Puts focus on the newWindow
	if (window.focus) {
		newWindow.focus();
	}
}
